export var DataCatalogSortField;
(function (DataCatalogSortField) {
    DataCatalogSortField["DATA_CATALOG_SORT_FIELD_CREATED_AT"] = "createdAt";
    DataCatalogSortField["DATA_CATALOG_SORT_FIELD_NAME"] = "name";
})(DataCatalogSortField || (DataCatalogSortField = {}));
